import React, { useState } from 'react';
import ScrollReveal from '../common/ScrollReveal';
import { PARTNERS_DATA } from '../../data/partnersData';
import katanaBg from '../../assets/images/partners-katana.svg';

function PartnersSection() {
  const [activePartner, setActivePartner] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  React.useEffect(() => {
    if (activePartner !== null) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prev) => 
          (prev + 1) % PARTNERS_DATA[activePartner].showcase.length
        );
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [activePartner]);

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      {/* Katana Background */}
      <div 
        className="absolute left-0 top-0 h-full w-full opacity-80"
        style={{
          backgroundImage: `url(${katanaBg})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          transform: 'rotate(-30deg) translateX(-37%) translateY(-52%)',
          filter: 'brightness(1.2)',
          pointerEvents: 'none',
          zIndex: 1
        }}
      />
      
      <div className="container mx-auto px-4 relative z-10 min-h-[460px] flex flex-col">
        <div className="flex justify-center mb-12">
          <h2 className="text-6xl font-morganite text-brand-white tracking-wider">PARTNERS</h2>
        </div>

        <div className="flex-1 flex items-center justify-center">
          <div className="grid grid-cols-1 min-[640px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {PARTNERS_DATA.map((partner, index) => (
            <ScrollReveal key={partner.id} delay={index * 0.1}>
              <div 
                className="relative mx-auto w-[280px] h-[160px] group"
                onMouseEnter={() => {
                  setActivePartner(index);
                  setCurrentImageIndex(0);
                }}
                onMouseLeave={() => {
                  setActivePartner(null);
                  setCurrentImageIndex(0);
                }}
              >
                <a 
                  href={partner.link}
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="block h-full w-full bg-white bg-opacity-5 rounded-xl overflow-hidden transition-all duration-300 hover:bg-opacity-10"
                >
                  {/* Logo Container */}
                  <div className={`absolute inset-0 flex items-center justify-center p-4 transition-opacity duration-300 
                    ${activePartner === index ? 'opacity-0' : 'opacity-100'}`}
                  >
                    <img 
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      className="max-h-full max-w-full object-contain rounded-lg"
                    />
                  </div>

                  {/* Showcase Container */}
                  {activePartner === index && (
                    <div className="absolute inset-0">
                      <img 
                        src={partner.showcase[currentImageIndex]}
                        alt={`${partner.name} showcase`}
                        className="w-full h-full object-cover rounded-xl"
                      />
                      <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black to-transparent rounded-b-xl">
                        <p className="text-white text-sm">
                          {partner.description}
                        </p>
                      </div>
                    </div>
                  )}
                </a>
              </div>
            </ScrollReveal>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PartnersSection;